// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HOYX","tabsBox":"styles_tabsBox__103tJ","createButton":"styles_createButton__3cpK6"};